export const pxToLatLng = (x: number, y: number, map: google.maps.Map, zoom?: number | null) => {
  const projection = map.getProjection?.()
  const bounds = map.getBounds?.()
  zoom ||= map.getZoom?.()
  if (!projection || !bounds || zoom == null) return null

  const topRight = projection.fromLatLngToPoint(bounds.getNorthEast())
  const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest())

  if (!topRight || !bottomLeft) return null

  const scale = 2 ** zoom
  return projection.fromPointToLatLng(
    new google.maps.Point(x / scale + bottomLeft.x, y / scale + topRight.y),
  )
}
